import { render, staticRenderFns } from "./FollowArtistPageFooter.vue?vue&type=template&id=0dc4a090&scoped=true"
import script from "./FollowArtistPageFooter.vue?vue&type=script&lang=js"
export * from "./FollowArtistPageFooter.vue?vue&type=script&lang=js"
import style0 from "./FollowArtistPageFooter.scss?vue&type=style&index=0&id=0dc4a090&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc4a090",
  null
  
)

export default component.exports